"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

var _Column = _interopRequireDefault(require("antd/es/table/Column"));

var _lodash = require("lodash");

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _payment = require("../../redux/payment/payment.types");

var _Util = require("../util/Util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

class IncentivesTable extends _react.PureComponent {
  constructor() {
    super(...arguments);

    this.createAdHoc = () => {
      const {
        requestAdHocPayment,
        participantId
      } = this.props;
      requestAdHocPayment(participantId);
    };
  }

  render() {
    const {
      participantIncentives
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.createAdHoc
    }, "Create Ad Hoc Payment Request"), /*#__PURE__*/_react.default.createElement("br", null), ' ', /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_table.default, {
      dataSource: participantIncentives,
      pagination: {
        pageSize: 20
      },
      rowClassName: rowClassName,
      rowKey: "incentivePaymentId"
    }, /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "ID",
      dataIndex: "incentivePaymentId",
      key: "incentivePaymentId",
      sorter: (a, b) => a.incentivePaymentId - b.incentivePaymentId
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Label",
      dataIndex: "label",
      key: "label",
      sorter: (a, b) => `${a.label}`.localeCompare(b.label),
      filters: _lodash._.map(_lodash._.sortedUniq(_lodash._.uniq(_lodash._.sortBy(_lodash._.map(participantIncentives, 'label')))), x => {
        return {
          text: x,
          value: x
        };
      }),
      onFilter: (value, record) => record.label === value
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: amount => `$${amount}`,
      sorter: (a, b) => a.amount - b.amount
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Create Date",
      dataIndex: "createDate",
      key: "createDate",
      render: _Util.renderDateWithoutTime,
      sorter: (a, b) => (0, _moment.default)(a.createDate).unix() - (0, _moment.default)(b.createDate).unix()
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Paid",
      dataIndex: "paidDate",
      key: "paidDate",
      render: paidDate => `${paidDate ? (0, _moment.default)(paidDate).calendar() : ''}`,
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        if (!a.paidDate && !b.paidDate) return 0;
        if (!a.paidDate && b.paidDate) return 1;
        if (a.paidDate && !b.paidDate) return -1;
        return (0, _moment.default)(a.paidDate).unix() - (0, _moment.default)(b.paidDate).unix();
      },
      filters: [{
        text: 'unpaid',
        value: 'unpaid'
      }],
      onFilter: (value, record) => value === 'unpaid' && !record.paidDate
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Order Number",
      dataIndex: "trackingInfo",
      key: "trackingInfo",
      sorter: (a, b) => `${a.trackingInfo}`.localeCompare(b.trackingInfo)
    })));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({});

const mapDispatchToProps = dispatch => {
  return {
    requestAdHocPayment: participantId => dispatch(_payment.requestAdHocPaymentAsync.request(participantId))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(IncentivesTable);

exports.default = _default;